export default {
  placeholder: 'Wybierz status',
};
